import React from "react";
import { useLanguageContext } from "@cadenza/i18n-react";
import { LANGUAGE_HANDLING } from "@cadenza/i18n-core";
import { MenuRoot, MenuButton, MenuList, MenuItem } from "@cadenza/ui";
import { FaGlobe } from "react-icons/fa";

const LanguageSelector = ({ menuListClassName = "dropdown-left" }) => {
  const {
    language,
    setLanguage,
    availableLanguages = [],
    labelsByCode = {},
    STRINGS = {},
  } = useLanguageContext() || {};

  const labelCurrent = labelsByCode[language] || "Language";
  const title = STRINGS[LANGUAGE_HANDLING.SELECT_LANGUAGE] || "Select language";

  return (
    <MenuRoot>
      {(api) => (
        <div>
          <MenuButton
            api={api}
            aria-label={title}
            title={title}
            className="actionButton"
            showCaret={false}
          >
            <FaGlobe className="cs-big-icon" />
          </MenuButton>

          <MenuList api={api} className={menuListClassName}>
            <MenuItem>
              <header>{labelCurrent}</header>
            </MenuItem>
            {availableLanguages.map((code) => (
              <MenuItem
                key={code}
                onSelect={() => {
                  setLanguage(code);
                  api.close();
                }}
              >
                <div>{labelsByCode[code] || code.toUpperCase()}</div>
              </MenuItem>
            ))}
          </MenuList>
        </div>
      )}
    </MenuRoot>
  );
};

export default LanguageSelector;
